import { NewEmployeeReportState } from '../interface/NewEmployeeReportInterface'
import { push } from 'connected-react-router'
import { LinkStuff } from '../interface/MyInterfaces'
import { handleReportDisplayIdChange_EmployeeReport, authenticateUserOutsideLogin } from './UserActions';
import { authHeader } from '../javascript/auth-header';
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import { arrayToCsv_NewEmployeeReport, numberWithCommas, toTitleCase, getStateNameFromAbbrev, getStateNameFromFIPSCode, isAgg } from '../components/Common/Helpers';

export function downloadNewEmployeeReportData(NewEmployeeReportState: NewEmployeeReportState) {
    const barplotData = NewEmployeeReportState.EmployeeBarPlot.map(item => {
        let stateName = getStateNameFromFIPSCode(item.statecode);
        return {
            ...item,
            stateName
        }
    })

    const boxplotData = NewEmployeeReportState.EmployeeBoxPlot.map(item => {
        let stateName = getStateNameFromFIPSCode(item.statecode);
        return {
            ...item,
            stateName
        }
    })
    const companyData = NewEmployeeReportState.EmployeeCompany.map(item => {
        let stateName = getStateNameFromFIPSCode(item.statecode);
        return {
            ...item,
            stateName
        }
    })
    fetch("/IRISReportsMicroservice/api/NewEmployeeReport/readme")
        .then(res => {
            if (!res.ok) {
                throw new Error('Network failed');
            }
            return res.blob();
        })
        .then(pdfblob => {
            const zip = new JSZip();
            const locationsCsv = arrayToCsv_NewEmployeeReport({ data: NewEmployeeReportState.EmployeeLocation });
            const nationalCsv = arrayToCsv_NewEmployeeReport({ data: NewEmployeeReportState.EmployeeNationalLocation });
            const chart1Csv = arrayToCsv_NewEmployeeReport({ data: barplotData });
            const chart2Csv = arrayToCsv_NewEmployeeReport({ data: boxplotData });
            const chart3Csv = arrayToCsv_NewEmployeeReport({ data: companyData });
            zip.file('destinationsmap_states.csv', locationsCsv);
            zip.file('destinationsmap_national.csv', nationalCsv);
            zip.file('chart1.csv', chart1Csv);
            zip.file('chart2.csv', chart2Csv);
            zip.file('chart3.csv', chart3Csv);

            zip.file("readme.pdf", pdfblob);
            zip.generateAsync({ type: "blob" })
                .then(function (blob) {
                    saveAs(blob, "EmployeeReportData.zip");
                });
        })
}

export function downloadNewEmployeeMethodologyPdf({
    display_id,
    vintage,
    university,
    EmployeeMethodology
}: {
    display_id: string;
    vintage: string;
    university: string;
    EmployeeMethodology: any;
}) {
    const now = new Date();
    const currentDateTime = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();
    const url = "/IRISReportsMicroservice/api/PDF/NewEmployeeReportPDF/generate_methodology_pdf";
    const headers = authHeader();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    const body = JSON.stringify({
        display_id,
        currentDateTime,
        vintage,
        university,
        isAgg: isAgg(display_id),
        EmployeeMethodology
    });

    return fetch(url, { method: 'POST', body, headers })
        .then(res => {
            if (!res.ok) {
                throw new Error('Network failed');
            }
            return res.blob();
        })
        .then(blob => {
            saveAs(blob, `EmployeeReport_Methodology_${currentDateTime}.pdf`);
        })
        .catch((error) => {
            console.log(error);
        });
}

export function loadReleaseDate(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/get_employee_release_date/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "EMPLOYEE_RELEASE",
                    payload: json['release_date']
                })
            });
    };
}

export function loadNewEmployeeReport(display_id, vintage) {

    return dispatch => {
        let x: NewEmployeeReportState = {
            showZoomed: 0,
        };
        dispatch({
            type: "EMPLOYEE_REPORT_LOADING",
            payload: x
        })
        dispatch(loadNewEmployeeCompany(display_id, vintage));
        dispatch(loadNewEmployeeBoxPlot(display_id, vintage));
        dispatch(loadNewEmployeeBarPlot(display_id, vintage));
        dispatch(loadNewEmployeeLocation(display_id, vintage));
        dispatch(loadNewEmployeeMethodology(display_id, vintage));
        dispatch(loadReleaseDate(display_id, vintage))
    }
}

export function loadNewEmployeeMethodology(display_id, vintage) {
    return dispatch => {
        const url = `/IRISReportsMicroservice/api/NewEmployeeReport/methodology/${display_id}/${vintage}`;
        const headers = authHeader();
        fetch(url, { method: 'GET', headers })
            .then(res => res.json())
            .then(data => {
                dispatch({
                    type: 'EMPLOYEE_METHODOLOGY',
                    payload: data[0]
                })

                dispatch(loadNewEmployeeProfileInfo(display_id, vintage));
                dispatch(tryBuildEmployeeLocationHighlights(display_id));
            })
    }
}

export function loadNewEmployeeProfileInfo(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/profile_info/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "EMPLOYEE_PROFILE_INFO",
                    payload: json[0]
                })
                dispatch(tryBuildEmployeeLocationHighlights(display_id));
            });
    };
}



export function loadNewEmployeeSharedReport(link_id, p1, p2) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        var headers = authHeader();
        fetch(url, {
            method: 'GET',
            headers: headers
        })
            .then(function (response) {
                return response.json();
            })
            .then(async function (json) {
                var link: LinkStuff = json;
                if (link.link_id == -1) {

                    dispatch({
                        type: "BAD_LINK",
                        payload: json
                    });
                    dispatch(push('/reports/bad_link'));
                } else {
                    await authenticateUserOutsideLogin();
                    dispatch(loadNewEmployeeReport(link.display_id, link.vintage));
                    dispatch(handleReportDisplayIdChange_EmployeeReport(
                        { value: link.display_id }));
                }
            });
    };
}

const getCorrectText = (reportDisplayId, university) => {
    let names = "";
    if (reportDisplayId == "999075" || reportDisplayId == "999087")
        names = "IRIS Member Universities";
    else if (reportDisplayId == "999077" || reportDisplayId == "999086")
        names = "Research Universities for Michigan";
    else if (reportDisplayId == "999076" || reportDisplayId == "999085")
        names = "Texas CPUPC IRIS Members";
    else
        names = university;
    return names;
}

// Aggregate reports don't always have state/state_fips on profile_info; map them explicitly.
const AGG_HOME_STATE_FIPS = {
    "999077": 26, // RU4M → Michigan
    "999086": 26, // RU4M → Michigan
    "999076": 48, // CPUPC → Texas
    "999085": 48, // CPUPC → Texas
};


export function loadNewEmployeeLocation(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/location/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let result = [];
                json.forEach(state => {
                    const lastThree = state.fips.substring(state.fips.length - 3);
                    if (lastThree == "000") {
                        result.push({ fips: state.statecode, statename: state.statename, count: state.count });
                    }
                });
                result = result.sort((a, b) => (a.count < b.count) ? 1 : -1);

                dispatch({
                    type: "EMPLOYEE_NATIONAL_LOCATION",
                    payload: result
                })
                dispatch({
                    type: "EMPLOYEE_LOCATION",
                    payload: json
                })
                dispatch(tryBuildEmployeeLocationHighlights(display_id));
            });
    };
}

// Highlights need location + profile + methodology years; any of those can arrive first.
function tryBuildEmployeeLocationHighlights(display_id) {
    return (dispatch, getState) => {
        const reportState: NewEmployeeReportState = getState().newEmployeeReportProperties;
        const json = reportState.EmployeeLocation;
        const profile = reportState.EmployeeProfileInfo;
        const methodology = reportState.EmployeeMethodology;
        if (!json || !profile || !methodology) return;

        const result = reportState.EmployeeNationalLocation || [];
        const { start_year, end_year } = methodology;
        const { state_fips: state_code, university, state, employees } = profile;

        let state_text = " loading ... ";
        let instate_percent = 0;

        const homeStateFips = AGG_HOME_STATE_FIPS[display_id] || state_code;
        const homeStateName = AGG_HOME_STATE_FIPS[display_id]
            ? getStateNameFromFIPSCode(homeStateFips)
            : getStateNameFromAbbrev(state);

        if (homeStateFips > 0) {
            let homeStateRow = json.filter(x => x.statecode == homeStateFips && x.fips.substring(x.fips.length - 3) == "000")[0];
            if (homeStateRow) {
                instate_percent = Math.round((homeStateRow.count / employees) * 100);
            }
        }

        if (result) {
            let onlythosewithvalues = result.filter(item => item.count >= 0);
            let reduced = [...new Set(onlythosewithvalues.map(item => item.statename))];
            if (reduced.includes("District of Columbia")) {
                state_text = ` ${reduced.length - 1} states and the District of Columbia.`;
            }
            else
                state_text = ` ${reduced.length} states.`;

            // In-state % for all reports except All IRIS (no single home state).
            // Top employers shows for all reports (including individual universities).
            // Temporary: hide hardcoded top-employers bullet for MTU (64556) and Georgia Tech (49222).
            const showInStateHighlight = display_id != "999075" && display_id != "999087";
            const showTopEmployersHighlight = display_id != "64556" && display_id != "49222";
            const inStateText = `Approximately <b>${instate_percent}%</b> of these research-funded employees found employment in the state of ${homeStateName}.`;
            const topEmployersText = 'The education, health care and information technology sectors were among the top employers.';

            dispatch({
                type: "STATE_TEXT",
                payload: `<b>${numberWithCommas(employees)}</b> employees funded by research grants at ${getCorrectText(display_id, university)} between ${start_year} and ${end_year} are now employed in<b>${state_text}</b>`
            })
            dispatch({
                type: "STATE_TEXT2",
                payload: showInStateHighlight ? inStateText : null
            })
            dispatch({
                type: "STATE_TEXT3",
                payload: showTopEmployersHighlight ? topEmployersText : null
            })
        }
    };
}

export function loadNewEmployeeCompany(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/company/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let toUpperCase = []
                toUpperCase = json.map(x => { return { company_name: x.company_name, count: x.count, employee: x.employee, industry: toTitleCase(x.industry), median_salary: x.median_salary, statecode: x.statecode } });
                dispatch({
                    type: "EMPLOYEE_COMPANY",
                    payload: toUpperCase
                })
            });
    };
}

export function loadNewEmployeeBoxPlot(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/boxplot/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let toUpperCase = []
                toUpperCase = json.map(x => { return { lower: x.lower, q1: x.q1, q3: x.q3, median: x.median, upper: x.upper, employee: x.employee, industry: toTitleCase(x.industry), statecode: x.statecode } });

                dispatch({
                    type: "EMPLOYEE_BOXPLOT",
                    payload: toUpperCase
                })
            });
    };
}
export function loadNewEmployeeBarPlot(display_id, vintage) {
    return (dispatch) => {
        let url = '/IRISReportsMicroservice/api/NewEmployeeReport/barplot/' + display_id + '/' + vintage;

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let toUpperCase = []
                toUpperCase = json.map(x => { return { count: x.count, employee: x.employee, industry: toTitleCase(x.industry), statecode: x.statecode } });
                dispatch({
                    type: "EMPLOYEE_BARPLOT",
                    payload: toUpperCase
                })
            });
    };
}

export function updateSelectedStateCode(stateCode) {
    return ({
        type: "SELECTED_STATE_CODE",
        payload: stateCode
    })
}

/*
export function loadEmployeeSharedReport(link_id, p1, p2) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        authenticateUserOutsideLogin();

        var headers = authHeader();
        fetch(url, {
            method: 'GET',
            headers: headers
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var link: LinkStuff = json;
                if (link.link_id == -1) {

                    dispatch({
                        type: "BAD_LINK",
                        payload: json
                    });
                    dispatch(push('/reports/bad_link'));
                } else {
                    dispatch(loadEmployeeReport(link.display_id, link.vintage));
                    dispatch(handleReportDisplayIdChange_EmployeeReport(
                        { value: link.display_id }));
                }
            });
    };
}
*/



/*
export function loadMatchRate(display_id, vintage, EmployeeProfileInfo) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/EmployeeReport/match_report_data/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "EMPLOYEE_MATCH_RATE",
                    payload: json[0]
                })
                dispatch(setMatchRateBullets(json[0], EmployeeProfileInfo));
            });
    };
}
*/
